import { render } from "./ProfileBranches.vue?vue&type=template&id=870db73e&scoped=true"
import script from "./ProfileBranches.vue?vue&type=script&lang=js"
export * from "./ProfileBranches.vue?vue&type=script&lang=js"

import "./ProfileBranches.vue?vue&type=style&index=0&id=870db73e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-870db73e"]])

export default __exports__